const COMPONENT_EVENTS = {
  Logout: {
    description: 'Triggered when user logs out',
    eventHub: {
      code: 'LOGOUT',
      action: 'Clicked logout'
    },
    ga: {
      action: 'Clicked logout'
    }
  },
  Save: {
    description: 'Triggered when user saves screen data',
    eventHub: {
      code: 'SAVE',
      action: 'Clicked save and continue'
    },
    ga: {
      action: 'Clicked save and continue'
    }
  },
  OpenedWhyAsk: {
    description: 'Triggered when why do we ask dialogue is shown',
    eventHub: {
      code: 'OPENEDWHYASK',
      action: 'Clicked why do we ask this'
    }
  }
};

const createEventAction = (eventAction, componentName) => {
  return [`${componentName ?? ''}`, `${eventAction ?? ''}`]
    .filter((str) => !!str)
    .join('_');
};

module.exports = {
  expectingParentApplicationComponentEvents: {
    Calculation: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'Calculation'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    FreePromotion: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'FreePromotion'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    EmploymentAndMarital: {
      code: 'EMPLOYMENTANDMARITAL',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'EmploymentAndMarital'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    IncomeAndDependents: {
      code: 'INCOMEANDDEPENDENTS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IncomeAndDependents'
            ),
            dataKeys: ['appType']
          }
        },
        save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'IncomeAndDependents'
            ),
            dataKeys: ['annualIncome', 'dependents']
          }
        },
        OpenedWhyAsk: {
          description: COMPONENT_EVENTS.OpenedWhyAsk.description,
          eventHub: {
            code: COMPONENT_EVENTS.OpenedWhyAsk.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.OpenedWhyAsk.eventHub.action,
              'IncomeAndDependents'
            )
          }
        }
      }
    },
    LiabilitiesAndAssets: {
      code: 'LIABILITIESANDASSETS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'LiabilitiesAndAssets'
            ),
            dataKeys: ['appType']
          }
        },
        Save: {
          description: COMPONENT_EVENTS.Save.description,
          eventHub: {
            code: COMPONENT_EVENTS.Save.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Save.eventHub.action,
              'LiabilitiesAndAssets'
            ),
            dataKeys: ['assetAmount', 'liabilitiesAmount']
          }
        },
        OpenedWhyAsk: {
          description: COMPONENT_EVENTS.OpenedWhyAsk.description,
          eventHub: {
            code: COMPONENT_EVENTS.OpenedWhyAsk.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.OpenedWhyAsk.eventHub.action,
              'LiabilitiesAndAssets'
            )
          }
        }
      }
    },
    InvestmentExperience: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'InvestmentExperience'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    IPSQuestions: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IPSQuestions'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    RiskProfile: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'RiskProfile'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    ConservativePlanNotice: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'ConservativePlanNotice'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    IDVGateway: {
      code: 'IDVGateway',
      events: {
        Click: {
          description: 'Triggered when user clicks on IDV FAQ link',
          eventHub: {
            code: 'CLICK',
            action: createEventAction('Clicked IDV FAQ', 'IDVGateway')
          }
        },
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IDVGateway'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    IDVerification: {
      code: 'IDVerification',
      events: {
        Retry: {
          eventHub: {
            code: 'RETRY',
            action: createEventAction('Clicked Try again', 'IDVerification')
          }
        },
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IDVerification'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    IDVFAQ: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'IDVFAQ'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    SubscriberInfo: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'SubscriberInfo'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    Grants: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'Grants'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    SubscriberSIN: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'SubscriberSIN'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    ApplicationReview: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'ApplicationReview'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    Success: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'Success'
            ),
            dataKeys: ['appType']
          }
        }
      }
    },
    Error: {
      code: 'PROJECTEDSAVINGS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(
              COMPONENT_EVENTS.Logout.eventHub.action,
              'Error'
            ),
            dataKeys: ['appType']
          }
        }
      }
    }
  }
};
